'use strict';

angular.module('mobile-apps')
  .directive('fitToWindowHeight',function($timeout, $window) {
    return {
      scope:
      {
        offset : '&fitToWindowHeightOffset'
      },
      link: function (scope, elem, attrs) {
        function setHeight()
		{
			//console.log('setHeight');
			var offset = scope.offset() || 0;
			var winHeight = $window.innerHeight - offset + 20;
			elem.css("height", winHeight + "px");
		}

        angular.element($window).on("resize", function()
        {
          $timeout(setHeight);
        });

        elem.on('$destroy', function() {
          return angular.element($window).off("resize", setHeight);
        });
        setHeight();
        $timeout(setHeight);
      }
    };
  });


